var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Jtron',{on:{"login":function($event){return _vm.$emit('login')}}}),_c('Wiki',{on:{"login":function($event){return _vm.$emit('login')}}}),_c('CategoryScroll',{on:{"login":function($event){return _vm.$emit('login')}}}),_c('Why')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }